export default __webpack_public_path__ + "assets/pdf/Sandeep Sreekumar.pdf";